import { connect } from "react-redux";
import PropTypes from "prop-types";
import ProjectFeedback from "common/components/project_feedback";

const mapStateToProps = ({ user }) => {
  return {
    user: user.profile_data,
  };
};

export default connect(mapStateToProps)(ProjectFeedback);
